import { State } from "processList/model/State";
import * as Redux from "redux";
import { ThunkResult, Utilities } from "shared/utilities";
import * as FetchActions from "./FetchActions";
import * as SelectActions from "./SelectProcessActions"
import { CleanOldVersionsDialogState, DeletableProcessVersions } from "processList/model/CleanOldVersionsDialogState";

export function cleanUpVersions(processId: number): ThunkResult<Promise<void>, State> {
    return async (dispatch) => {
        try {
            dispatch(FetchActions.fetchStart(FetchActions.FetchId.cleanUpVersions));
            await Utilities.deleteFetchAndParseResponse(`api/processList/deleteProcessVersions`, {
                processId
            });
            dispatch(FetchActions.fetchFinish(FetchActions.FetchId.cleanUpVersions));
            Utilities.toastSuccess("Process version cleanup messages sent successfully");
            dispatch(SelectActions.deselectAllProcesses());
            dispatch(closeCleanVersionsDialog());
        } catch (error) {
            dispatch(FetchActions.reportFetchError(error));
        }
    };
}

export const OPEN_CLEAN_VERSIONS_DIALOG = "OPEN_CLEAN_VERSIONS_DIALOG";

export interface OpenCleanVersionsDialogAction extends Redux.Action {
    dialogState: CleanOldVersionsDialogState;
}

export function openCleanVersionsDialog(processGuid: string): ThunkResult<Promise<void>, State> {
    return async (dispatch) => {
        try {
            const fetchedDeletableProcessVersions = await Utilities.getFetch<DeletableProcessVersions>("api/processList/deletableProcessVersions", {
                processGuid
            });
            dispatch(setCleanVersionsDialogState(processGuid, fetchedDeletableProcessVersions))

        } catch (error) {
            dispatch(FetchActions.reportFetchError(error));
        }
    };
}

function setCleanVersionsDialogState(processGuid: string, fetchedDeletableProcessVersions: DeletableProcessVersions): OpenCleanVersionsDialogAction {
    return {
        type: OPEN_CLEAN_VERSIONS_DIALOG,
        dialogState: {
            showDialog: true,
            processGuid,
            deletableProcessVersions: fetchedDeletableProcessVersions,
            processesMarkedForDeletion: {}
        }
    };
}

export const UPDATE_PROCESSES_MARKED_FOR_DELETION = "UPDATE_PROCESSES_MARKED_FOR_DELETION";
export interface UpdateProcessMarkedForDeletionAction extends Redux.Action {
    newValue: number;
    processName: string;
}
export function onSetProcessesMarkedForDeletion(newValue: number, processName: string): UpdateProcessMarkedForDeletionAction {
    return {
        type: UPDATE_PROCESSES_MARKED_FOR_DELETION,
        newValue,
        processName
    };
}

export const CLOSE_CLEAN_VERSIONS_DIALOG = "CLOSE_CLEAN_VERSIONS_DIALOG";
export function closeCleanVersionsDialog(): Redux.Action {
    return {
        type: CLOSE_CLEAN_VERSIONS_DIALOG
    };
}
